import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const FeatureCard = ({ 
  icon: Icon, 
  title, 
  description, 
  variant = 'default',
  sx = {}
}) => {
  const getCardStyles = () => {
    switch (variant) {
      case 'problem':
        return {
          backgroundColor: 'grey.50',
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'grey.200'
        };
      case 'benefit':
        return {
          backgroundColor: 'transparent'
        };
      default:
        return {
          backgroundColor: 'grey.50',
          borderRadius: '16px',
          border: '1px solid rgba(25, 118, 210, 0.1)',
          boxShadow: '0 8px 32px -12px rgba(0,0,0,0.1)',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 40px -12px rgba(0,0,0,0.15)'
          }
        };
    }
  };

  const getIconStyles = () => {
    switch (variant) {
      case 'problem':
        return {
          fontSize: 32,
          color: 'error.main'
        };
      case 'benefit':
        return {
          fontSize: 32,
          color: 'common.black',
          mt: 0.5
        };
      default:
        return {
          fontSize: 20,
          color: '#1976d2'
        };
    }
  };

  return (
    <Paper elevation={0} sx={{ p: 3, height: '100%', ...getCardStyles(), ...sx }}>
      {variant === 'default' ? (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
          <Box sx={{
            p: 1,
            borderRadius: '8px',
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 40,
            height: 40
          }}>
            <Icon sx={getIconStyles()} />
          </Box>
          <Typography variant="h6" sx={{
            fontWeight: 700,
            color: '#0A2540',
            fontSize: '1.25rem',
            flex: 1
          }}>
            {title}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: variant === 'benefit' ? 'flex-start' : 'center', gap: variant === 'benefit' ? 2 : 1, mb: 1.5 }}>
          <Icon sx={getIconStyles()} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      )}
      <Typography variant="body1" sx={{
        color: '#546E7A',
        fontSize: '1.1rem',
        lineHeight: 1.6,
        ml: variant === 'default' ? 7 : 0,
        overflowWrap: 'break-word'
      }}>
        {description}
      </Typography>
    </Paper>
  );
};

export default FeatureCard; 